module.exports = __webpack_public_path__ + "img/company-logo.95d3c066.svg";